import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { Dropdown } = themeColorSectionKeys.shared

export const enum ParkCallMenuItemVariants {
  Available = 'available',
  Unavailable = 'unavailable',
}

const parkCallMenuItemParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(parkCallMenuItemParts)
export const ParkCallMenuItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      alignItems: 'center',
      paddingY: '0.5rem',
      paddingX: '0.75rem',
      gap: '0.5rem',
      borderRadius: '0.5rem',
    },
    text: {
      userSelect: 'none',
      textStyle: textStyleKeys.Body1,
      lineHeight: '1.5rem',
    },
  },
  variants: {
    [ParkCallMenuItemVariants.Available]: {
      container: {
        cursor: 'pointer',
        _hover: { backgroundColor: Dropdown.Items.Background.Hover },
        _active: { backgroundColor: Dropdown.Items.Background.Active },
      },
    },
    [ParkCallMenuItemVariants.Unavailable]: {
      container: {
        cursor: 'default',
      },
    },
  },
})

export const useParkCallMenuItemStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof parkCallMenuItemParts>(
    getName({ ParkCallMenuItemStyle }),
    props,
  )
}
